export default "__VITE_ASSET__H4bXMRCS__"